import * as React from 'react';

import {
  UitkTable,
  UitkTableCol,
  UitkTableColGroup,
  UitkTableHead,
  UitkTableRow,
  UitkTableBody,
  UitkTableCell,
} from 'uitk-react-tables';
import { LocalizedText } from '@shared-ui/localization-context';

export const CommissionTable = () => (
  <UitkTable>
    <UitkTableColGroup>
      <UitkTableCol />
      <UitkTableCol />
      <UitkTableCol />
    </UitkTableColGroup>
    <UitkTableHead>
      <UitkTableRow>
        <UitkTableCell>
          <LocalizedText message={'programs.cards.features.commission_category.label'} />
        </UitkTableCell>
        <UitkTableCell>
          <LocalizedText message={'programs.cards.features.commission.label'} />
        </UitkTableCell>
      </UitkTableRow>
    </UitkTableHead>
    <UitkTableBody>
      <UitkTableRow>
        <UitkTableCell>
          <LocalizedText message={'programs.cards.lobs.flights'} />
        </UitkTableCell>
        <UitkTableCell>$2</UitkTableCell>
      </UitkTableRow>
      <UitkTableRow>
        <UitkTableCell>
          <LocalizedText message={'programs.cards.lobs.hotel'} />
        </UitkTableCell>
        <UitkTableCell>3%</UitkTableCell>
      </UitkTableRow>
      <UitkTableRow>
        <UitkTableCell>
          <LocalizedText message={'programs.cards.lobs.vacationRentals'} />
        </UitkTableCell>
        <UitkTableCell>2%</UitkTableCell>
      </UitkTableRow>
      <UitkTableRow>
        <UitkTableCell>
          <LocalizedText message={'programs.cards.lobs.package'} />
        </UitkTableCell>
        <UitkTableCell>2%</UitkTableCell>
      </UitkTableRow>
      <UitkTableRow>
        <UitkTableCell>
          <LocalizedText message={'programs.cards.lobs.groundTransfers'} />
        </UitkTableCell>
        <UitkTableCell>5%</UitkTableCell>
      </UitkTableRow>
      <UitkTableRow>
        <UitkTableCell>
          <LocalizedText message={'programs.cards.lobs.activities'} />
        </UitkTableCell>
        <UitkTableCell>5%</UitkTableCell>
      </UitkTableRow>
      <UitkTableRow>
        <UitkTableCell>
          <LocalizedText message={'programs.cards.lobs.cruise'} />
        </UitkTableCell>
        <UitkTableCell>6%</UitkTableCell>
      </UitkTableRow>
      <UitkTableRow>
        <UitkTableCell>
          <LocalizedText message={'programs.cards.lobs.car'} />
        </UitkTableCell>
        <UitkTableCell>2%</UitkTableCell>
      </UitkTableRow>
    </UitkTableBody>
  </UitkTable>
);
